@let isFree = bundleItem().slotType === 'free';

@if (isFree) {
  <span class="free-label mobile">Gratis für Sie</span>
}

<div class="wrapper-content">
  <img [src]="bundleItem().images[0].small" [alt]="bundleItem().images[0].large">
  <div class="wrapper-attributes">
    <span [matTooltip]="bundleItem().details.name" class="name">{{ bundleItem().details.name }}</span>
    <span class="attribute">VE: {{ bundleItem().details.packagingUnit }}</span>
    <span class="attribute">Menge {{ bundleItem().quantity }}</span>
  </div>

  <div class="wrapper-prices">
    @if (isFree) {
      <span class="free-label desktop">Gratis für Sie</span>
    } @else if (!bundleItem().prices?.redacted) {
      <ui-product-prices-formatter class="price" [price]="(bundleItem().prices?.salesUnit ?? 0) * bundleItem().quantity"></ui-product-prices-formatter>
    }

    @if (!bundleItem().prices?.redacted && bundleItem().prices?.salesUnitDeposit) {
      <span class="deposit">zzgl. Pfand:
    <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="(bundleItem().prices?.salesUnitDeposit ?? 0) * bundleItem().quantity"></ui-product-prices-formatter>
  </span>
    }
  </div>
</div>
